import Vue from 'vue'
import Router from 'vue-router'
import Api from '../axios/api'

import login from '@/view/login'
import error from '@/view/error'
import welcome from '@/view/welcome'
import home from '@/view/home'

import user from '@/view/settings/user'
import role from '@/view/settings/role'
import permission from '@/view/settings/permission'
import permission_upload from '@/view/settings/permission-upload'

import overview from '@/view/order/overview/overview'
import overviewMobile from '@/view/order/overview/overview-mobile'
import dealTimer from '@/view/order/overview/deal-timer'
import createrCount from '@/view/order/overview/creater-count'
import orderManage from '@/view/order/order-manage/order-manage'
import createOrder from '@/view/order/order-manage/create-order'
import orderDetail from '@/view/order/order-manage/order-detail'
import knowledge from '@/view/order/knowledge/knowledge'
import faq from '@/view/order/knowledge/faq'
import productCategorySetting from '@/view/order/order-settings/product-category-setting'
import remindRoles from '@/view/order/order-settings/remind-roles'

import salesOverview from '@/view/statistics/sales/overview'
import performance from '@/view/statistics/sales/performance'
import salesCount from '@/view/statistics/sales/sales-count'
import salesDetail from '@/view/statistics/sales/sales-detail'
import skuManage from '@/view/statistics/sales/sku-manage'
import appOperation from '@/view/statistics/app/app-operation'
import multiBindUser from '@/view/statistics/app/multi-bind-user'
import deviceOperation from '@/view/statistics/device/device-operation'
import deviceFailure from '@/view/statistics/device/device-failure'
import deviceLifecycle from '@/view/statistics/device/device-lifecycle'
import deviceGeo from '@/view/statistics/device/device-geo'
import deviceClean from '@/view/statistics/device/device-clean'

import msgManage from '@/view/app/market-manage/msg-manage'
import feedback from '@/view/app/user-feedback/user-feedback'
import feedbackDetail from '@/view/app/user-feedback/feedback-detail'
import mallManage from '@/view/app/market-manage/mall-manage'
import bannerManage from '@/view/app/market-manage/banner-manage'
import updateSettings from '@/view/app/market-manage/update-settings'
import groupManage from '@/view/app/market-manage/group-manage'
import pscFileManage from '@/view/app/product-service-center/file-manage'
import pscFaqManage from '@/view/app/product-service-center/faq'
import pscFaqUpdate from '@/view/app/product-service-center/faq-update'
import pscMalfunction from '@/view/app/product-service-center/malfunction'
import pscMalfunctionUpdate from '@/view/app/product-service-center/malfunction-update'
import community from '@/view/app/community/list'
import communityManage from '@/view/app/community/content-manage'
import communityTagManage from '@/view/app/community/tag-manage'

import userDetail from '@/view/iot/user-manage/user-detail'
import userManage from '@/view/iot/user-manage/user-manage'
import deviceDetail from '@/view/iot/device-manage/device-detail'
import deviceManage from '@/view/iot/device-manage/device-manage'

import productInfo from '@/view/product/product-data/product-info'
import snManage from '@/view/product/product-data/sn-manage'
import productManage from '@/view/product/product-data/product-manage'
import activationCode from '@/view/product/cat-litter-card/activation-code-manage'
import catLitterCardOrder from '@/view/product/cat-litter-card/order'

import renewOrder from '@/view/product/renew/order'
import renewReview from '@/view/product/renew/review'

import ptAccountSetting from '@/view/product-test-tool/account/setting'
import cbUploadSn from '@/view/product-test-tool/cat-box/upload-sn'
import cbQuerySn from '@/view/product-test-tool/cat-box/query-sn'
import cbSw from '@/view/product-test-tool/cat-box/sw'
import s1ExportSn from '@/view/product-test-tool/s1/export-sn'
import s1Setting from '@/view/product-test-tool/s1/setting'
import weightSetting from '@/view/product-test-tool/weight/setting'
import weightLog from '@/view/product-test-tool/weight/log'
Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'login',
			component: login,
		},{
			path: '/error',
			name: 'error',
			component: error,
		},{
			path: '/welcome',
			name: 'welcome',
			redirect: '/home/index',
			component: welcome,
			children: [
				{
					path: '/home/index',
					name: 'home',
					meta: {
						title: '首页'
					},
					component: home,
				},{
					path: '/settings/user',
					name: 'user',
					meta: {
						title: '成员管理'
					},
					component: user,
				},{
					path: '/settings/role',
					name: 'role',
					meta: {
						title: '角色管理'
					},
					component: role,
				},{
					path: '/settings/role/permission',
					name: 'permission',
					meta: {
						title: '角色权限'
					},
					component: permission,
				},{
					path: '/settings/permission-upload',
					name: 'permission-upload',
					meta: {
						title: '角色权限'
					},
					component: permission_upload,
				},{
					path: '/work-order/overview',
					name: 'overview',
					meta: {
						title: '工单总览'
					},
					component: overview,
				},{
					path: '/work-order/overview-mobile',
					name: 'overview-mobile',
					meta: {
						title: '总览'
					},
					component: overviewMobile,
				},{
					path: '/work-order/deal-timer',
					name: 'deal-timer',
					meta: {
						title: '处理耗时统计'
					},
					component: dealTimer,
				},{
					path: '/work-order/creater-count',
					name: 'creater-count',
					meta: {
						title: '工单创建人统计'
					},
					component: createrCount,
				},{
					path: '/work-order/order-manage',
					name: 'order-manage',
					meta: {
						title: '工单管理'
					},
					component: orderManage,
				},{
					path: '/work-order/order-manage/create-order',
					name: 'create-order',
					meta: {
						title: '新建工单'
					},
					component: createOrder,
				},{
					path: '/work-order/order-manage/order-detail/:id',
					name: 'order-detail',
					meta: {
						title: '工单详情'
					},
					component: orderDetail,
				},{
					path: '/work-order/knowledge',
					name: 'knowledge',
					meta: {
						title: '知识库'
					},
					component: knowledge,
				},{
					path: '/work-order/knowledge/faq/:id',
					name: 'faq',
					meta: {
						title: 'Faq'
					},
					component: faq,
				},{
					path: '/work-order/product-category-setting',
					name: 'product-category-setting',
					meta: {
						title: '产品分类配置'
					},
					component: productCategorySetting,
				},{
					path: '/work-order/remind-roles',
					name: 'remind-roles',
					meta: {
						title: '超时未响应工单提醒'
					},
					component: remindRoles,
				},{
					path: '/statistics/sales/overview',
					name: 'sales-overview',
					meta: {
						title: '销售总览'
					},
					component: salesOverview,
				},{
					path: '/statistics/sales/performance',
					name: 'performance',
					meta: {
						title: '业绩报表'
					},
					component: performance,
				},{
					path: '/statistics/sales/sales-count',
					name: 'sales-count',
					meta: {
						title: '销售统计'
					},
					component: salesCount,
				},{
					path: '/statistics/sales-detail',
					name: 'sales-detail',
					meta: {
						title: '销售统计明细'
					},
					component: salesDetail,
				},
				{
					path: '/statistics/sku-manage',
					name: 'sku-manage',
					meta: {
						title: 'SKU-人员配置'
					},
					component: skuManage,
				},{
					path: '/statistics/app-operation',
					name: 'app-operation',
					meta: {
						title: 'APP运营报表'
					},
					component: appOperation,
				},{
					path: '/statistics/multi-bind-user',
					name: 'multi-bind-user',
					meta: {
						title: '多设备绑定用户'
					},
					component: multiBindUser,
				},{
					path: '/statistics/device-operation',
					name: 'device-operation',
					meta: {
						title: '设备运营报表'
					},
					component: deviceOperation,
				},{
					path: '/statistics/device-failure',
					name: 'device-failure',
					meta: {
						title: '设备故障统计'
					},
					component: deviceFailure,
				},{
					path: '/statistics/device-lifecycle',
					name: 'device-lifecycle',
					meta: {
						title: '设备生命周期'
					},
					component: deviceLifecycle,
				},{
					path: '/statistics/device-geo',
					name: 'device-geo',
					meta: {
						title: '设备地域分布'
					},
					component: deviceGeo,
				},{
					path: '/statistics/device-clean',
					name: 'device-clean',
					meta: {
						title: '设备清扫分析'
					},
					component: deviceClean,
				},{
					path: '/app/msg-manage',
					name: 'msg-manage',
					meta: {
						title: '消息推送管理'
					},
					component: msgManage,
				},
				{
					path: '/app/user-feedback',
					name: 'user-feedback',
					meta: {
						title: '用户反馈'
					},
					component: feedback,
				},{
					path: '/app/user-feedback/feedback-detail/:id',
					name: 'feedback-detail',
					meta: {
						title: '反馈详情'
					},
					component: feedbackDetail,
				},{
					path: '/app/mall-manage',
					name: 'app-mall-manage',
					meta: {
						title: 'APP 商城配置'
					},
					component: mallManage,
				},{
					path: '/app/banner-manage',
					name: 'app-banner-manage',
					meta: {
						title: 'APP 广告配置'
					},
					component: bannerManage,
				},{
					path: '/app/update-settings',
					name: 'app-update-settings',
					meta: {
						title: 'APP 升级配置'
					},
					component: updateSettings,
				},{
					path: '/app/group-manage',
					name: 'app-group-manage',
					meta: {
						title: 'APP群组管理'
					},
					component: groupManage,
				},{
					path: '/app/psc-file-manage',
					name: 'psc-file-manage',
					meta: {
						title: '产品服务中心'
					},
					component: pscFileManage,
				},
				{
					path: '/app/psc-faq-manage',
					name: 'psc-faq-manage',
					meta: {
						title: '产品常见问题管理'
					},
					component: pscFaqManage,
				},
				{
					path: '/app/psc-faq-update',
					name: 'psc-faq-update',
					meta: {
						title: '产品常见问题编辑'
					},
					component: pscFaqUpdate,
				},
				{
					path: '/app/psc-malfunction',
					name: 'psc-malfunction',
					meta: {
						title: '故障排查'
					},
					component: pscMalfunction,
				},
				{
					path: '/app/psc-malfunction-update',
					name: 'psc-malfunction-update',
					meta: {
						title: '产品故障问题编辑'
					},
					component: pscMalfunctionUpdate,
				},
				{
					path: '/app/community/list',
					name: 'community-list',
					meta: {
						title: '社区列表'
					},
					component: community,
				},
				{
					path: '/app/community/manage',
					name: 'community-manage',
					meta: {
						title: '社区内容管理'
					},
					component: communityManage,
				},
				{
					path: '/app/community/tag',
					name: 'community-tag',
					meta: {
						title: '标签管理'
					},
					component: communityTagManage,
				},
				{
					path: '/iot/user-manage/user-manage',
					name: 'user-manage',
					meta: {
						title: '用户管理'
					},
					component: userManage,
				},{
					path: '/iot/user-manage/user-detail/:id',
					name: 'user-detail',
					meta: {
						title: '用户详情'
					},
					component: userDetail,
				},
				{
					path: '/iot/device-manage/device-manage',
					name: 'device-manage',
					meta: {
						title: '设备管理'
					},
					component: deviceManage,
				},{
					path: '/iot/device-manage/device-detail/:id',
					name: 'device-detail',
					meta: {
						title: '设备详情'
					},
					component: deviceDetail,
				},{
					path: '/product/product-info',
					name: 'product-info',
					meta: {
						title: '产品注册信息'
					},
					component: productInfo,
				},{
					path: '/product/sn-manage',
					name: 'sn-manage',
					meta: {
						title: 'SN号管理'
					},
					component: snManage,
				},{
					path: '/product/product-manage',
					name: 'product-manage',
					meta: {
						title: '产品管理'
					},
					component: productManage,
				},{
					path: '/product/cat-litter-card/activation-code',
					name: 'activation-code',
					meta: {
						title: '猫砂卡管理'
					},
					component: activationCode,
				},{
					path: '/product/cat-litter-card/order',
					name: 'cat-litter-card-order',
					meta: {
						title: '猫砂卡兑换订单'
					},
					component: catLitterCardOrder,
				},{
					path: '/product/renew/order',
					name: 'renew-order',
					meta: {
						title: '以旧换新活动'
					},
					component: renewOrder,
				},{
					path: '/product/renew/review',
					name: 'renew-review',
					meta: {
						title: '以旧换新活动'
					},
					component: renewReview,
				},{
					path: '/product-test-tool/cat-box/upload-sn',
					name: 'cb-upload-sn',
					meta: {
						title: 'SN号上传'
					},
					component: cbUploadSn,
				},{
					path: '/product-test-tool/cat-box/query-sn',
					name: 'cb-query-sn',
					meta: {
						title: '查询SN号'
					},
					component: cbQuerySn,
				},{
					path: '/product-test-tool/cat-box/sw',
					name: 'cb-sw',
					meta: {
						title: '软件版本号设置'
					},
					component: cbSw,
				},{
					path: '/product-test-tool/s1/export-sn',
					name: 's1-export-sn',
					meta: {
						title: '导出SN号'
					},
					component: s1ExportSn,
				},{
					path: '/product-test-tool/s1/setting',
					name: 's1-setting',
					meta: {
						title: 'S1产测设置'
					},
					component: s1Setting,
				},{
					path: '/product-test-tool/weight/setting',
					name: 'weight-setting',
					meta: {
						title: '称重设置'
					},
					component: weightSetting,
				},{
					path: '/product-test-tool/weight/log',
					name: 'weight-log',
					meta: {
						title: '称重记录'
					},
					component: weightLog,
				},{
					path: '/product-test-tool/account/setting',
					name: 'pt-account-setting',
					meta: {
						title: '产测账号设置'
					},
					component: ptAccountSetting,
				}
			]
		}
	]
})
router.beforeEach((to, from, next) => {
	if(to.name == 'login' || to.name == 'error') {
	}else{
		Api.pagePush({route: to.matched[to.matched.length - 1].path.split('/:')[0]}).then(() => {})
	}
	next();
	
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js